/* mp-avvisami.js — ESAURITO e «Avvisami quando torna» (Stefano 29-09-2026). Contratto col portale: docs/avvisami/portale.md.
   - Card: [data-mp-avvisami] apre la finestra col modulo (il <template id="mpa-modulo"> di head.liquid).
   - Scheda: [data-mpa-scheda] ha il modulo già stampato (mp-avvisami-scheda).
   - Profilo: [data-mpa-profilo] mostra «I miei avvisi».
   Invio: con avvisami.stato.attivo (portale acceso) → POST /apps/naso/avvisami; se no → modulo contatti di Shopify in un iframe
   nascosto: la richiesta arriva al negozio per email, niente si perde. Il browser ricorda gli avvisi (localStorage «mp-avvisami») per
   dire subito «Ti avviseremo» su card, scheda e profilo. Configurazione: window.mpAvvisami (head.liquid). */
(function () {
  var C = window.mpAvvisami || {};
  var CANALI = C.canali && C.canali.length ? C.canali : ['email'];
  var PROXY = (C.proxy || '/apps/naso').replace(/\/$/, '');
  var CHIAVE = 'mp-avvisami';
  var NOMI = { email: 'email', sms: 'SMS', whatsapp: 'WhatsApp' };
  var seq = 0;

  function leggi() { try { var l = JSON.parse(localStorage.getItem(CHIAVE) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function scrivi(l) { try { localStorage.setItem(CHIAVE, JSON.stringify(l.slice(-60))); } catch (e) {} }
  // gli avvisi del cliente salvati dal portale (metafield avvisami.handles): valgono anche su un altro telefono
  var TOLTI = {};
  function sulPortale(h) { return !TOLTI[h] && !!(C.cliente && C.cliente.handles && C.cliente.handles.indexOf(h) > -1); }
  function trova(h) {
    return leggi().filter(function (a) { return a.handle === h; })[0] ||
      (sulPortale(h) ? { handle: h, canali: [], nota: 'Hai già chiesto l\'avviso per questo profumo: ti scriviamo come hai scelto.' } : null);
  }
  function segna(dati, on) { var l = leggi().filter(function (a) { return a.handle !== dati.handle; }); if (on) l.push(dati); else TOLTI[dati.handle] = 1; scrivi(l); dipingi(); }
  function dipingi() {
    var l = leggi();
    Array.prototype.forEach.call(document.querySelectorAll('[data-mp-avvisami]'), function (b) {
      var h = b.getAttribute('data-mp-avvisami'), on = sulPortale(h) || l.some(function (a) { return a.handle === h; });
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function elenco(nomi) { return nomi.length > 1 ? nomi.slice(0, -1).join(', ') + ' e ' + nomi[nomi.length - 1] : (nomi[0] || ''); }
  // «+393331234567» → «+39 333 123 4567» (prefissi del modulo; gli altri numeri restano come sono)
  function leggibile(t) {
    t = String(t || '');
    var m = /^\+(39|41|378|33|49|43|34|44|32|31|1)(\d{6,})$/.exec(t); if (!m) return t;
    var r = m[2], g = r.length > 7 ? [r.slice(0, 3), r.slice(3, 6), r.slice(6)] : [r.slice(0, 3), r.slice(3)];
    return '+' + m[1] + ' ' + g.join(' ');
  }
  function riepilogo(a) {
    var pezzi = (a.canali || []).map(function (c) { return c === 'email' ? 'email a ' + a.email : NOMI[c] + ' al ' + leggibile(a.telefono); });
    return pezzi.length ? 'Ti scriviamo per ' + elenco(pezzi) + '.' : '';
  }
  // numero internazionale (E.164): «333 123 4567» col prefisso scelto, «0039…» e «+…» come sono
  function numero(pref, v) {
    var s = String(v || '').replace(/[^\d+]/g, '');
    if (!s) return null;
    if (s.indexOf('00') === 0) s = '+' + s.slice(2);
    if (s.charAt(0) !== '+') s = pref + s;
    var cifre = s.slice(1).replace(/\D/g, '');
    return cifre.length >= 8 && cifre.length <= 15 ? '+' + cifre : null;
  }

  // ———— invio ————
  function invia(d) {
    var corpo = { handle: d.handle, prodotto_id: d.prodotto_id, variante_id: d.variante_id, titolo: d.titolo, canali: d.canali, email: d.email, telefono: d.telefono, fonte: d.fonte };
    if (!C.attivo) return perContatti(d);
    return fetch(PROXY + '/avvisami', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(corpo) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { s: r.status, j: j || {} }; }); })
      .then(function (x) {
        if (x.s >= 200 && x.s < 300 && x.j.ok !== false) return x.j;
        if (x.s === 409 && x.j.motivo === 'gia_disponibile') { setTimeout(function () { location.reload(); }, 1600); throw 'È appena tornato disponibile: ricarico la pagina.'; }
        if (x.s === 429) throw 'Troppe richieste in poco tempo: riprova fra qualche minuto.';
        throw (typeof x.j.messaggio === 'string' && x.j.messaggio) || 'Non è andato a buon fine. Riprova tra poco.';
      }, function () { throw 'Non è andato a buon fine. Controlla la connessione e riprova.'; });
  }
  // finché il portale non è acceso: il modulo contatti di Shopify (arriva al negozio), inviato in un iframe nascosto
  function perContatti(d) {
    return new Promise(function (ok, no) {
      var nome = 'mpa-invio-' + Date.now();
      var fr = document.createElement('iframe'); fr.name = nome; fr.hidden = true; fr.tabIndex = -1; fr.setAttribute('aria-hidden', 'true');
      var f = document.createElement('form'); f.method = 'post'; f.action = '/contact#contact_form'; f.target = nome; f.acceptCharset = 'UTF-8'; f.hidden = true;
      var testo = '[Avvisami quando torna] ' + d.titolo + ' (' + d.handle + ', variante ' + d.variante_id + ')\n' +
        'Canali: ' + d.canali.map(function (c) { return NOMI[c]; }).join(', ') + '\n' +
        (d.email ? 'Email: ' + d.email + '\n' : '') + (d.telefono ? 'Telefono: ' + d.telefono + '\n' : '') + 'Da: ' + d.fonte + ' · ' + location.pathname;
      var campi = { form_type: 'contact', utf8: '✓', 'contact[email]': d.email, 'contact[name]': (C.cliente && C.cliente.nome) || '', 'contact[phone]': d.telefono || '', 'contact[body]': testo };
      Object.keys(campi).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = campi[k]; f.appendChild(i); });
      var fatto = false;
      var pulisci = function () { setTimeout(function () { fr.remove(); f.remove(); }, 400); };
      var t = setTimeout(function () { if (fatto) return; fatto = true; pulisci(); no('Non è andato a buon fine. Riprova tra poco.'); }, 20000);
      fr.addEventListener('load', function () {
        if (fatto) return;
        var dove = ''; try { dove = fr.contentWindow.location.href; } catch (e) {}
        if (!dove || dove === 'about:blank') return;
        fatto = true; clearTimeout(t); pulisci();
        if (/contact_posted=true/.test(dove)) ok({});
        else if (/challenge/.test(dove)) no('Serve una verifica anti-spam: riprova fra un momento.');
        else no('Non è andato a buon fine. Controlla l\'email e riprova.');
      });
      document.body.appendChild(fr); document.body.appendChild(f); f.submit();
    });
  }
  function togli(h) {
    if (C.attivo && C.cliente) {
      return fetch(PROXY + '/avvisami/togli', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ handle: h }) })
        .then(function (r) { if (!r.ok) throw 0; }, function () { throw 0; });
    }
    return Promise.resolve();
  }

  var giaChiesti = null;
  function recapiti() {
    if (!giaChiesti) giaChiesti = fetch(PROXY + '/avvisami', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return (j && j.recapiti) || null; }, function () { return null; });
    return giaChiesti;
  }
  // ———— il modulo (scheda e finestra) ————
  function lega(box, p, fonte, alFatto) {
    var form = box.querySelector('[data-mpa-modulo]'), fattoEl = box.querySelector('[data-mpa-fatto]');
    if (!form || form._mpa) return; form._mpa = true;
    var q = function (s) { return form.querySelector(s); };
    var inEmail = q('[name=email]'), inTel = q('[name=telefono]'), pref = q('[name=prefisso]'), err = q('[data-mpa-errore]'), btn = q('[data-mpa-invia]');
    var campoEmail = q('[data-per=email]'), campoTel = q('[data-per=telefono]'), perCosa = q('[data-mpa-per-cosa]');
    Array.prototype.forEach.call(form.querySelectorAll('.mpa-campo'), function (c) {
      var id = 'mpa-' + (++seq), l = c.querySelector('label'), i = c.querySelector('input'); if (l && i) { i.id = id; l.htmlFor = id; }
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-canale]'), function (l) { l.hidden = CANALI.indexOf(l.getAttribute('data-canale')) < 0; });
    // se l'email non è fra i canali, il primo canale visibile parte scelto
    var visibili = function () { return Array.prototype.filter.call(form.querySelectorAll('[name=canale]'), function (i) { return !i.closest('[data-canale]').hidden; }); };
    if (!visibili().some(function (i) { return i.checked; }) && visibili()[0]) visibili()[0].checked = true;
    // un canale solo (oggi l'email): niente scelta da fare, si chiede solo il recapito
    var scelta = form.querySelector('.mpa-canali'); if (scelta) scelta.hidden = visibili().length < 2;
    if (C.cliente) {
      if (C.cliente.email && !inEmail.value) inEmail.value = C.cliente.email;
      var t = String(C.cliente.telefono || '');
      if (t && !inTel.value) {
        var opz = Array.prototype.map.call(pref.options, function (o) { return o.value; }).sort(function (a, b) { return b.length - a.length; });
        var m = opz.filter(function (v) { return t.indexOf(v) === 0; })[0];
        if (m) { pref.value = m; inTel.value = t.slice(m.length); } else inTel.value = t;
      }
    }
    // cliente collegato: gli ultimi recapiti scritti nel modulo (GET del portale, «recapiti») vanno già nei campi
    if (C.attivo && C.cliente) recapiti().then(function (r) {
      if (!r) return;
      if (r.email && (!inEmail.value || inEmail.value === C.cliente.email)) inEmail.value = r.email;
      if (r.telefono && !inTel.value) {
        var t = String(r.telefono), opz = Array.prototype.map.call(pref.options, function (o) { return o.value; }).sort(function (a, b) { return b.length - a.length; });
        var m = opz.filter(function (v) { return t.indexOf(v) === 0; })[0];
        if (m) { pref.value = m; inTel.value = t.slice(m.length); } else inTel.value = t;
      }
    });
    function scelti() { return visibili().filter(function (i) { return i.checked; }).map(function (i) { return i.value; }); }
    function aggiorna() {
      var s = scelti(), tel = s.filter(function (c) { return c !== 'email'; });
      // senza il portale la richiesta arriva al negozio per email: lì l'email serve sempre
      campoEmail.hidden = !(s.indexOf('email') > -1 || !C.attivo);
      campoTel.hidden = !tel.length;
      if (perCosa) perCosa.textContent = tel.length ? 'per ' + elenco(tel.map(function (c) { return NOMI[c]; })) : '';
    }
    function errore(m) { err.textContent = m; err.hidden = false; }
    function mostraFatto(a) {
      var r = box.querySelector('[data-mpa-riepilogo]'); if (r) r.textContent = a.nota || riepilogo(a);
      var t = box.querySelector('[data-mpa-fatto-t]'); if (t) t.textContent = a.stato === 'da_confermare' ? 'Manca un passo: conferma dall\'email.' : 'Fatto. Ti avvisiamo quando torna.';
      form.hidden = true; if (fattoEl) fattoEl.hidden = false;
      if (alFatto) alFatto();
    }
    function mostraModulo() { form.hidden = false; if (fattoEl) fattoEl.hidden = true; }
    form.addEventListener('change', function (e) { if (e.target.name === 'canale') { aggiorna(); err.hidden = true; } });
    form.addEventListener('input', function (e) { e.target.classList.remove('is-errore'); err.hidden = true; });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      var s = scelti();
      if (!s.length) return errore('Scegli almeno un modo: email, SMS o WhatsApp.');
      var email = inEmail.value.trim(), tel = '';
      if (!campoEmail.hidden && !/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]{2,}$/.test(email)) { inEmail.classList.add('is-errore'); inEmail.focus(); return errore('Controlla l\'email: sembra incompleta.'); }
      if (!campoTel.hidden) { tel = numero(pref.value, inTel.value); if (!tel) { inTel.classList.add('is-errore'); inTel.focus(); return errore('Controlla il numero: serve il numero completo, col prefisso giusto.'); } }
      var d = { handle: p.handle, prodotto_id: p.prodotto_id, variante_id: p.variante_id, titolo: p.titolo, foto: p.foto, canali: s, email: campoEmail.hidden ? '' : email, telefono: tel, fonte: fonte, il: new Date().toISOString() };
      btn.disabled = true; var prima = btn.textContent; btn.textContent = 'Un attimo…';
      invia(d).then(function (j) {
        // ospite col portale acceso: il portale manda un'email di conferma (link valido un'ora) e lo dice nel «messaggio»
        var av = (j && j.avviso) || {};
        d.stato = av.stato || 'attivo';
        if (d.stato === 'da_confermare') d.nota = (typeof j.messaggio === 'string' && j.messaggio) || 'Ti abbiamo scritto: conferma dal link nell\'email.';
        segna(d, true); mostraFatto(d);
      }, function (m) { errore(typeof m === 'string' ? m : 'Non è andato a buon fine. Riprova tra poco.'); })
        .then(function () { btn.disabled = false; btn.textContent = prima; });
    });
    var bTogli = box.querySelector('[data-mpa-togli]');
    if (bTogli) bTogli.addEventListener('click', function () {
      bTogli.disabled = true;
      togli(p.handle).then(function () { segna({ handle: p.handle }, false); mostraModulo(); }, function () { errore('Non riesco a togliere l\'avviso adesso: riprova tra poco.'); mostraModulo(); })
        .then(function () { bTogli.disabled = false; });
    });
    aggiorna();
    var gia = trova(p.handle);
    if (gia) {
      if ((gia.canali || []).length) visibili().forEach(function (i) { i.checked = gia.canali.indexOf(i.value) > -1; });
      if (gia.email) inEmail.value = gia.email;
      aggiorna(); mostraFatto(gia);
    }
  }

  // ———— la finestra dalle card ————
  var aperta = null;
  function chiudi() {
    if (!aperta) return;
    var v = aperta; aperta = null;
    v.velo.remove(); document.documentElement.classList.remove('mpa-fermo');
    document.removeEventListener('keydown', v.tasti);
    if (v.da && v.da.focus) v.da.focus({ preventScroll: true });
  }
  function apri(b) {
    var tpl = document.getElementById('mpa-modulo'); if (!tpl) return;
    chiudi();
    var p = { handle: b.getAttribute('data-mp-avvisami'), prodotto_id: +b.getAttribute('data-id') || null, variante_id: +b.getAttribute('data-variante') || null, titolo: b.getAttribute('data-titolo') || '', foto: b.getAttribute('data-foto') || '' };
    var velo = document.createElement('div'); velo.className = 'mpa-velo';
    var fin = document.createElement('div'); fin.className = 'mpa-finestra';
    fin.setAttribute('role', 'dialog'); fin.setAttribute('aria-modal', 'true'); fin.setAttribute('aria-label', 'Avvisami quando torna: ' + p.titolo);
    fin.innerHTML = '<button type="button" class="mpa-finestra__chiudi" aria-label="Chiudi"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="mpa-finestra__testa"><span class="mpa-finestra__foto"><img alt=""></span><div><p class="mpa-finestra__k">Sold out</p><p class="mpa-finestra__nome"></p></div></div>' +
      '<p class="mpa-finestra__p">L\'ultimo lotto è finito. Lasciaci un recapito: quando esce il prossimo ti avvisiamo, una volta sola.</p>';
    var img = fin.querySelector('img'); if (p.foto) img.src = p.foto; else img.removeAttribute('src');
    fin.querySelector('.mpa-finestra__nome').textContent = p.titolo;
    if (b.hasAttribute('data-pausa')) {
      fin.querySelector('.mpa-finestra__k').textContent = 'Non disponibile';
      fin.querySelector('.mpa-finestra__p').textContent = 'Torna con la prossima uscita. Lasciaci un recapito: quando riapre ti avvisiamo, una volta sola.';
    }
    fin.appendChild(tpl.content.cloneNode(true));
    velo.appendChild(fin); document.body.appendChild(velo);
    document.documentElement.classList.add('mpa-fermo');
    var tasti = function (e) {
      if (e.key === 'Escape') return chiudi();
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(fin.querySelectorAll('button, input, select, a[href]'), function (x) { return !x.disabled && x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    };
    aperta = { velo: velo, tasti: tasti, da: b };
    document.addEventListener('keydown', tasti);
    velo.addEventListener('click', function (e) { if (e.target === velo) chiudi(); });
    fin.querySelector('.mpa-finestra__chiudi').addEventListener('click', chiudi);
    lega(fin, p, 'card');
    var primo = fin.querySelector('.mpa-canale:not([hidden]) input'); if (primo) primo.focus({ preventScroll: true });
  }
  // la barra in basso della scheda porta al riquadro
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mpa-vai]')) return;
    var s = document.querySelector('[data-mpa-scheda]'); if (!s) return;
    e.preventDefault();
    s.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    var i = s.querySelector('[data-mpa-modulo]:not([hidden]) .mpa-campo:not([hidden]) input'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 450);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mp-avvisami]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); apri(b);
  }, true);

  // ———— la scheda ————
  // la barra in basso compare solo dopo aver superato il riquadro (il modulo del tema è nascosto: da sola comparirebbe subito)
  var scheda = document.querySelector('[data-mpa-scheda]'), barra = document.querySelector('cart-bar');
  if (scheda && barra && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (v) {
      var r = v[0].boundingClientRect;
      barra.classList.toggle('mpa-via', v[0].isIntersecting || r.top > 0);
    }).observe(scheda);
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-mpa-scheda]'), function (s) {
    lega(s, { handle: s.getAttribute('data-handle'), prodotto_id: +s.getAttribute('data-id') || null, variante_id: +s.getAttribute('data-variante') || null, titolo: s.getAttribute('data-titolo') || '', foto: s.getAttribute('data-foto') || '' }, 'scheda');
  });

  // ———— il profilo: «I miei avvisi» ————
  var prof = document.querySelector('[data-mpa-profilo]');
  function statoVoce(li, tornato, daConfermare) {
    li.className = 'mpa-profilo__voce ' + (tornato ? 'is-tornato' : 'is-esaurito');
    li.querySelector('.mpa-profilo__stato').textContent = tornato ? 'È tornato disponibile' : daConfermare ? 'Da confermare: apri il link nell\'email' : 'Sold out · ti avvisiamo appena torna';
    var az = li.querySelector('.mpa-profilo__azioni'), c = az.querySelector('.mpa-profilo__compra');
    if (tornato && !c) { c = document.createElement('a'); c.className = 'mpa-profilo__compra'; c.href = li.getAttribute('data-url'); c.textContent = 'Compra'; az.insertBefore(c, az.firstChild); }
  }
  function mostraProfilo(avvisi, dalPortale) {
    var lista = prof.querySelector('[data-mpa-lista]'), vuoto = prof.querySelector('[data-mpa-vuoto]'), conta = document.querySelector('[data-mpa-conta]');
    var numeri = function () {
      var n = lista.children.length;
      lista.hidden = !n; vuoto.hidden = !!n;
      if (conta) { conta.textContent = n || ''; conta.hidden = !n; }
    };
    lista.innerHTML = '';
    (avvisi || []).filter(function (a) { return a && a.handle && a.stato !== 'tolto'; }).forEach(function (a) {
      var url = '/products/' + encodeURIComponent(a.handle);
      var li = document.createElement('li'); li.setAttribute('data-url', url);
      li.innerHTML = '<a class="mpa-profilo__foto" href="' + url + '" tabindex="-1" aria-hidden="true"><img alt="" loading="lazy"></a>' +
        '<div><a class="mpa-profilo__nome" href="' + url + '"></a><span class="mpa-profilo__stato"></span><span class="mpa-profilo__canali"></span></div>' +
        '<div class="mpa-profilo__azioni"><button type="button" class="mpa-link" data-togli>Togli</button></div>';
      var img = li.querySelector('img'); if (a.foto || a.immagine) img.src = a.foto || a.immagine;
      li.querySelector('.mpa-profilo__nome').textContent = a.titolo || a.handle;
      li.querySelector('.mpa-profilo__canali').textContent = riepilogo({ canali: a.canali || [], email: a.email || (C.cliente && C.cliente.email) || '', telefono: a.telefono || '' });
      statoVoce(li, dalPortale && (a.disponibile === true || a.stato === 'avvisato'), a.stato === 'da_confermare');
      // la lista di questo browser non sa se è tornato: lo chiede al negozio (il 50 ml, come mp-esaurito)
      if (!dalPortale || !a.immagine) {
        fetch(url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          if (!img.getAttribute('src') && p.featured_image) img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          if (dalPortale) return;
          var v = (p.variants || []).filter(function (x) { var t = String(x.title || '').toLowerCase().replace(/\s/g, ''); return t.indexOf('50ml') > -1 && t.indexOf('150ml') < 0; })[0];
          if (v ? v.available : p.available) statoVoce(li, true, false);
        }).catch(function () {});
      }
      li.querySelector('[data-togli]').addEventListener('click', function (e) {
        var b = e.currentTarget; b.disabled = true;
        togli(a.handle).then(function () { segna({ handle: a.handle }, false); li.remove(); numeri(); }, function () { b.disabled = false; b.textContent = 'Riprova'; });
      });
      lista.appendChild(li);
    });
    numeri();
  }
  if (prof) {
    if (C.attivo && C.cliente) {
      fetch(PROXY + '/avvisami', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) { mostraProfilo(j.avvisi || [], true); }, function () { mostraProfilo(leggi(), false); });
    } else mostraProfilo(leggi(), false);
  }

  // riapertura fissata (martin.vendita.torna_il): «fra 3 giorni e 4 ore»
  Array.prototype.forEach.call(document.querySelectorAll('[data-mpa-conto]'), function (el) {
    var quando = Date.parse(String(el.getAttribute('data-mpa-conto')).replace(/([+-]\d\d)(\d\d)$/, '$1:$2'));
    if (isNaN(quando)) return;
    var passo = function () {
      var m = Math.round((quando - Date.now()) / 60000);
      if (m <= 0) { el.textContent = 'Riapre adesso'; return; }
      var g = Math.floor(m / 1440), o = Math.floor((m % 1440) / 60), mi = m % 60;
      var p = g ? [g + (g === 1 ? ' giorno' : ' giorni'), o + (o === 1 ? ' ora' : ' ore')] : o ? [o + (o === 1 ? ' ora' : ' ore'), mi + ' min'] : [mi + ' min'];
      el.textContent = 'Fra ' + elenco(p.filter(function (x) { return x.charAt(0) !== '0'; }));
      setTimeout(passo, 30000);
    };
    passo();
  });

  dipingi();
  window.addEventListener('storage', function (e) { if (e.key === CHIAVE) dipingi(); });
  // ———— carrello: un profumo diventato sold out (o fermato dall'app) chiude «Procedi al pagamento» finché non lo si toglie ————
  var AVVISO_CASSA = 'Nel carrello c\'è un profumo non più disponibile: toglilo per procedere al pagamento.';
  function fermo() { return !!document.querySelector('.cart__item[data-mpa-fermo]'); }
  function cassa() {
    var f = fermo();
    Array.prototype.forEach.call(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'), function (b) {
      if (f) { b.disabled = true; b.setAttribute('data-mpa-chiuso', ''); }
      else if (b.hasAttribute('data-mpa-chiuso')) { b.disabled = false; b.removeAttribute('data-mpa-chiuso'); }
      var box = b.closest('[data-cart-checkout-buttons]') || b.parentNode, m = box.querySelector('.mpa-cassa');
      if (f && !m) { m = document.createElement('p'); m.className = 'mpa-cassa'; m.setAttribute('role', 'alert'); m.textContent = AVVISO_CASSA; box.insertBefore(m, box.firstChild); }
      if (!f && m) m.remove();
    });
  }
  // anche se il tema riabilita il bottone dopo un aggiornamento: al pagamento non si passa
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[name="checkout"], a[href^="/checkout"], .additional-checkout-buttons'); if (!b || !fermo()) return;
    e.preventDefault(); e.stopPropagation(); cassa();
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter; if (!fermo() || !sub || sub.name !== 'checkout') return;
    e.preventDefault(); e.stopPropagation(); cassa();
  }, true);

  // card arrivate dopo (filtri, «carica altri», preferiti) e carrello aggiornato: si ridipingono
  var attesa = 0;
  new MutationObserver(function () { clearTimeout(attesa); attesa = setTimeout(function () { dipingi(); cassa(); }, 150); }).observe(document.body, { childList: true, subtree: true });
  cassa();
})();
